import { isScannerUpgradeProposal } from 'components/ITeroProposal';
import { ContentfulEnvVariables, IteroProposalClient } from 'types';

const isFusePromotionMatching = (
  proposal: IteroProposalClient,
  promotionCode: string,
  promotionName: string
): boolean => {
  if (!proposal.promotion && !proposal.lineitems) {
    return false;
  }

  const uppercasePromotion = proposal.promotion?.toUpperCase();
  const nameMatches =
    uppercasePromotion?.includes(promotionName.toUpperCase()) || false;

  const codeMatches = proposal.lineitems.some(
    lineItem =>
      lineItem.promotion?.programCode
        ?.toUpperCase()
        .includes(promotionCode.toUpperCase()) || false
  );

  return nameMatches || codeMatches;
};

export const isLuminaSkuMatching = (
  proposal: IteroProposalClient = {
    lineitems: [],
  } as unknown as IteroProposalClient,
  LUMINA_SKUS = ''
) => {
  if (!LUMINA_SKUS) {
    return false;
  }
  const LUMINA_SKUS_TRANSFORMED = LUMINA_SKUS.split(',').map(sku => sku.trim());
  if (!proposal.lineitems || proposal.lineitems.length === 0) {
    return false;
  }

  const luminaLineItem = proposal.lineitems.find(lineItem =>
    LUMINA_SKUS_TRANSFORMED.find(sku => lineItem.sku === sku)
  );

  return Boolean(luminaLineItem);
};

const isCustomerNeedListMatching = (
  proposal: IteroProposalClient | undefined,
  customerNeedList: string[]
): boolean => {
  if (!proposal || !proposal.customerNeed) {
    return false;
  }

  return customerNeedList.includes(proposal.customerNeed);
};

const handleITeroCustomerNeeds = (
  proposal: IteroProposalClient,
  contentfulEnvVariables: ContentfulEnvVariables = {}
) => {
  const isSerialNumber =
    (proposal.existingScannerSerialNumber?.length ?? 0) > 0;

  const isUpgradeProposal = isScannerUpgradeProposal(proposal);
  const isServiceTermHideRequired = isUpgradeProposal;
  const isSerialNumberRequired = isSerialNumber;
  const isFuse25 = isFusePromotionMatching(proposal, 'FUSE25', 'Fusion 25');
  const isFuse45 = isFusePromotionMatching(proposal, 'FUSE45', 'Fusion 45');
  const isRental = proposal.saleType?.toLowerCase() === 'rental';
  const isLumina =
    isRental &&
    isLuminaSkuMatching(proposal, contentfulEnvVariables.LUMINA_SKUS);
  const isLuminaGoBeyondRentConvert =
    proposal.processType?.toLowerCase() === 'rentconvert';
  const isSprintRay = isCustomerNeedListMatching(proposal, [
    'SprintRay Midas',
    'SprintRay Pro2',
  ]);

  return {
    isServiceTermHideRequired,
    isSerialNumberRequired,
    isUpgradeProposal,
    isFuse25,
    isFuse45,
    isRental,
    isLumina,
    isLuminaGoBeyondRentConvert,
    isSprintRay,
  };
};

export default handleITeroCustomerNeeds;
